import React, { Fragment } from 'react'
import DoubleIndicator from '../../Common/Icon/DoubleIndicator'
import SingleIndicator from '../../Common/Icon/SingleIndicator'
import * as RoutePaths from '../../Entities/RoutePath'
import IndicatorsList from './IndicatorsList'
import useCustomNavigate from '../../Common/ui/Navigate'

const IndicatorMenu = () => {
    const customNavigate = useCustomNavigate()

    const handleSingleIndicator = () => {
        customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.INDICATORS.URI + RoutePaths.INDICATORS.ONE_SIDE, <div>{RoutePaths.INDICATORS.NAME}</div>)
    }

    const handleDoubleIndicator = () => {
        customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.INDICATORS.URI + RoutePaths.INDICATORS.DOUBLE_SIDE, <div>{RoutePaths.INDICATORS.NAME}</div>)
    }

    return (
        <Fragment>
            <div className='indicatorsMenu bg-[#eff6ff] w-full min-h-[14rem]'>
                <p className='flex flex-row justify-end pt-5 pr-10'>About</p>
                <div className='flex flex-row '>
                    <span className='cursor-pointer' onClick={handleSingleIndicator}>
                        <SingleIndicator />
                    </span>
                    <span className='cursor-pointer' onClick={handleDoubleIndicator}>
                        <DoubleIndicator />
                    </span>
                </div>
            </div>
            <IndicatorsList />
        </Fragment>
    )
}

export default IndicatorMenu
